module.exports = __webpack_public_path__ + "img/wa.ae05353c.png";